(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ===== MEGA MENU HOVER PRO ===== */

document.querySelectorAll('header-menu').forEach(menu => {

  const details = menu.querySelector('details');

  if (!details) return;

  let timeout;

  menu.addEventListener('mouseenter', () => {

    if (window.innerWidth >= 990) {

      clearTimeout(timeout);

      details.setAttribute('open', true);
    }
  });

  menu.addEventListener('mouseleave', () => {

    if (window.innerWidth >= 990) {

      timeout = setTimeout(() => {

        details.removeAttribute('open');

      }, 120);
    }
  });

});

/* ===== LANGUAGE SWITCH + MENU FIX ===== */

document.addEventListener('DOMContentLoaded', () => {

  const btnEs = document.getElementById('btn-es');
  const btnEn = document.getElementById('btn-en');

  function updateLanguageUI(lang){

    btnEs?.classList.remove('active');
    btnEn?.classList.remove('active');

    if(lang === 'en'){
      btnEn?.classList.add('active');
    } else {
      btnEs?.classList.add('active');
    }

    document.querySelectorAll('[data-es]').forEach(el => {

      el.innerHTML =
        lang === 'en'
        ? el.dataset.en
        : el.dataset.es;

    });

  }

  const currentLang =
    window.location.pathname.startsWith('/en')
    ? 'en'
    : 'es';

  updateLanguageUI(currentLang);

  document.querySelectorAll('.language-switcher a').forEach(link => {

    link.addEventListener('click', () => {

      document.body.classList.add('language-loading');

    });

  });

});
/* =========================================
   VERO MINI CART — STABLE
========================================= */

document.addEventListener('click', function(e){

  const trigger =
    e.target.closest('.vero-cart-trigger');

  const cartWrap =
    document.querySelector('.vero-cart-wrap');

  /* OPEN MOBILE */

  if(trigger && window.innerWidth <= 768){

    e.preventDefault();

    if(cartWrap){

      cartWrap.classList.toggle('active');
    }

    return;
  }

  /* CLOSE OUTSIDE */

  if(
    window.innerWidth <= 768 &&
    cartWrap &&
    !cartWrap.contains(e.target)
  ){

    cartWrap.classList.remove('active');
  }

});

/* =========================================
   AUTO OPEN AFTER ADD
========================================= */

document.addEventListener('submit', function(e){

  const form =
    e.target.closest('form[action*="/cart/add"]');

  if(form && window.innerWidth <= 768){

    setTimeout(() => {

      const cartWrap =
        document.querySelector('.vero-cart-wrap');

      if(cartWrap){

        cartWrap.classList.add('active');
      }

    }, 1000);

  }

});
/* =========================================
   REFRESH HEADER CART
========================================= */

function refreshVeroCart(){

  fetch('/?section_id=header')

    .then(res => res.text())

    .then(html => {

      const parser =
        new DOMParser();

      const doc =
        parser.parseFromString(html, 'text/html');

      const newCart =
        doc.querySelector('.vero-cart-wrap');

      const currentCart =
        document.querySelector('.vero-cart-wrap');

      if(newCart && currentCart){

        currentCart.innerHTML =
          newCart.innerHTML;
      }

    });

}

/* CART PAGE CHANGES */

document.addEventListener('change', function(e){

  const qtyInput =
    e.target.closest('input[name="updates[]"]');

  if(qtyInput){

    setTimeout(() => {

      refreshVeroCart();

    }, 700);

  }

});

/* REMOVE */

document.addEventListener('click', function(e){

  const removeBtn =
    e.target.closest('cart-remove-button a');

  if(removeBtn){

    setTimeout(() => {

      refreshVeroCart();

    }, 700);

  }

});
/* ===== VERO ACCOUNT MOBILE ===== */

const veroAccount = document.querySelector('.vero-account');

if(veroAccount){

  veroAccount.addEventListener('click', function(e){

    if(window.innerWidth <= 768){

      e.preventDefault();

      veroAccount.classList.toggle('active');

    }

  });

  document.addEventListener('click', function(e){

    if(window.innerWidth <= 768){

      if(!veroAccount.contains(e.target)){

        veroAccount.classList.remove('active');

      }

    }

  });

}

  } catch(e) { console.error(e); }
})();
})();
